import sleep from '../util/sleep';
import AisleController from './aisle-controller';

const COMMAND_INTERVAL_MS = 100;

class AllAisleTestRunner {
    constructor({siteId, portIdsByControllerIp, callbackOnStart, callbackOnStop}) {
        this.siteId = siteId;
        this.callbackOnStart = callbackOnStart;
        this.callbackOnStop = callbackOnStop;
        this.timeout = null;
        this.runEndtime = 0;
        this.isRunning = false;
        this.aisleControllers = {};
        this.aisles = [];
        for (const controllerIp in portIdsByControllerIp) {
            this.aisleControllers[controllerIp] = new AisleController(siteId, controllerIp);
            for (const portId of portIdsByControllerIp[controllerIp]) {
                this.aisles.push({controllerIp, portId});
            }
        }
    }

    async start(patternId, durationMs) {
        this.isRunning = true;

        try {
            this.callbackOnStart && this.callbackOnStart();
            await this._reset();
            await this._run(patternId, durationMs);
        } catch (e) {
            console.log(e);
        }
    }

    stop = async() => {
        if (this.isRunning) {
            this.isRunning = false;
        }

        this.callbackOnStop && this.callbackOnStop();
        await this._reset();
    }

    async _run(patternId, durationMs) {
        //we will make two calls one for each ledController in the cluster(Aisles : A1 to A52) to Light Up  Aisles with port ids list as parameter
        const portIdsMap = {};
        for(var aisle of this.aisles) {
            if(!portIdsMap[aisle.controllerIp]) {
                portIdsMap[aisle.controllerIp] = [];
            }
            portIdsMap[aisle.controllerIp].push(aisle.portId);
        }
        for(var ip in portIdsMap) {
            if (this._shouldContinue()) {
                await this.aisleControllers[ip].start(portIdsMap[ip], patternId, durationMs);
                await sleep(COMMAND_INTERVAL_MS);
            }
        }
        if (this._shouldContinue()) {
            this.timeout = setTimeout(this.stop, durationMs);
            this._setRunEndtime(durationMs);
        } else {
            await this.stop();
        }
    }

    async _reset() {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.runEndtime = 0;

        const stopPromises = [];
        for (const controllerIp in this.aisleControllers) {
            stopPromises.push(this.aisleControllers[controllerIp].stopAll());
        }
        await Promise.all(stopPromises);
        await sleep(COMMAND_INTERVAL_MS);
    }

    _setRunEndtime(durationMs) {
        this.runEndtime = Date.now() + parseInt(durationMs, 10);
    }

    _shouldContinue() {
        return this.isRunning;
    }
}

export default AllAisleTestRunner;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/business/all-aisle-test-runner.js